import { IFormTypesGroupCategoryService } from "../../service/formconfiguration/FormTypesGroupCategoryService";

export default class GetFormTypesGroupCategoriesInteractor {
  private formTypesGroupCategoryService: IFormTypesGroupCategoryService;

  constructor(formTypesGroupCategoryService) {
    this.formTypesGroupCategoryService = formTypesGroupCategoryService;
  }

  async execute() {
    return this.formTypesGroupCategoryService.getFormTypesGroupCategories();
  }
}
